import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=6fc03049&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc03049')) {
      api.createRecord('6fc03049', component.options)
    } else {
      api.reload('6fc03049', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=6fc03049&", function () {
      api.rerender('6fc03049', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mMR6hz7nidw8/JS/comp/ErrorMessage.vue"
export default component.exports